import { render, staticRenderFns } from "./CustomerMovements.vue?vue&type=template&id=6570f35a&scoped=true"
import script from "./CustomerMovements.vue?vue&type=script&lang=js"
export * from "./CustomerMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570f35a",
  null
  
)

export default component.exports